export const CircularProgress = ({
  progress = 0,
  radius = 45,
  strokeWidth = 8,
}) => {
  // Ensure progress is between 0 and 100
  const normalizedProgress = Math.min(100, Math.max(0, progress));

  // Calculate the stroke-dashoffset for the progress arc
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset =
    circumference - (normalizedProgress / 100) * circumference;

  // Calculate SVG size based on radius and stroke width
  const svgSize = (radius + strokeWidth) * 2;
  const center = svgSize / 2;

  return (
    <svg width={svgSize} height={svgSize}>
      {/* Background circle */}
      <circle
        stroke="#CED5DE"
        strokeWidth={strokeWidth}
        fill="transparent"
        r={radius}
        cx={center}
        cy={center}
      />
      {/* Progress circle */}
      <circle
        stroke="#3788EE"
        strokeWidth={strokeWidth}
        fill="transparent"
        r={radius}
        cx={center}
        cy={center}
        strokeDasharray={circumference}
        strokeDashoffset={strokeDashoffset}
        strokeLinecap="round"
        transform={`rotate(-90 ${center} ${center})`}
        style={{
          transition: "stroke-dashoffset 0.35s ease-in-out",
        }}
      />
    </svg>
  );
};
